export const PLOT_DEVELOPMENT_STATUSES = ['developer', 'owner'] as const

export type PlotDevelopmentStatus = (typeof PLOT_DEVELOPMENT_STATUSES)[number]

export function plotDevelopmentStatusLabel(status: PlotDevelopmentStatus): string {
  const labels: Record<PlotDevelopmentStatus, string> = {
    developer: 'Developer',
    owner: 'Owner',
  }
  return labels[status]
}

/** Parse spreadsheet / form values (e.g. "Developer", "Owner"). */
export function normalizePlotDevelopmentStatus(
  raw: string | null | undefined,
): PlotDevelopmentStatus | null {
  if (!raw?.trim()) return null
  const key = raw.trim().toLowerCase()
  if (key === 'developer') return 'developer'
  if (key === 'owner') return 'owner'
  return null
}
